import React from 'react';
import { Link } from "react-router-dom";

const BlogArticleCard = ({ id, coverImg, title, date }) => {
    return (
        <div className="bg-black border-2 border-lightgrey flex flex-col items-center gap-5 w-full xl:h-[400px] rounded-md shadow-md">

            <div className="w-full h-[350px] bg-cover bg-center rounded-md" style={{ backgroundImage: `url(${coverImg})` }} />

            <div className="w-full flex flex-col gap-5 justify-between px-2 pb-2.5">

                <p className="font-agrandir text-white text-[12px] mt-[0px]">{date}</p>

                <Link to={"/dashboard/blogapp/view/" + id} className="font-pressura cursor-pointer flex items-center buttonviolet text-[14px]">Accéder à l'article</Link>

            </div>
        </div>
    )
}

export default BlogArticleCard